import { render, staticRenderFns } from "./HistoricoCertificacao.vue?vue&type=template&id=7c541b2c&lang=pug"
import script from "./HistoricoCertificacao.vue?vue&type=script&lang=js"
export * from "./HistoricoCertificacao.vue?vue&type=script&lang=js"
import style0 from "./HistoricoCertificacao.vue?vue&type=style&index=0&id=7c541b2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports